import * as React from "react";
import {
  InputElementUnion,
  MaximumValidationSchema,
  MinimumValidationSchema,
  NumberElementUnion,
} from "@graffer-inc/form-schema";

// this file is based on NumberValidationEditor of form-builder
// see: https://github.com/graffer-inc/graffer-schemas/blob/70784b3c071948bd221f8268b58112603a8d87fd/libs/packages/form-builder/lib/elements/editor-pane/element-editor/editors/number-validation-editor.tsx

export const NumberValidationEditor: React.FC<{
  element: NumberElementUnion;
  onElementUpdate: (arg: InputElementUnion) => void;
}> = ({ element }) => {
  const maxValueSchema = element.validations.find(
    (elem) => elem.keyword === "maximum",
  ) as MaximumValidationSchema | undefined;
  const minValueSchema = element.validations.find(
    (elem) => elem.keyword === "minimum",
  ) as MinimumValidationSchema | undefined;

  return (
    <>
      <div className="field">
        <label className="label">入力規則設定</label>
      </div>
      <div className="field">
        <label className="label">最大値</label>
        <div className="control">
          {maxValueSchema ? <p>{maxValueSchema.value}</p> : <p>設定なし</p>}
        </div>
      </div>
      <div className="field">
        <label className="label">最小値</label>
        <div className="control">
          {minValueSchema ? <p>{minValueSchema.value}</p> : <p>設定なし</p>}
        </div>
      </div>
    </>
  );
};
